import { lazy, Suspense } from "react";
import Navbar from "@/components/Navbar";
import Seo from "@/components/Seo";
import HeroSection from "@/components/HeroSection";

// Below-the-fold sections — lazy-loaded so they don't block LCP
// and their Supabase queries run after the hero is painted.
const ServicesGrid = lazy(() => import("@/components/ServicesGrid"));
const PopularSearches = lazy(() => import("@/components/PopularSearches"));
const FeaturedExperiences = lazy(() => import("@/components/FeaturedExperiences"));
const AboutSection = lazy(() => import("@/components/AboutSection"));
const TestimonialsSection = lazy(() => import("@/components/TestimonialsSection"));
const DestinationsSection = lazy(() => import("@/components/DestinationsSection"));
const RecentlyViewedCarousel = lazy(() => import("@/components/RecentlyViewedCarousel"));
const SpecialOffersCarousel = lazy(() => import("@/components/SpecialOffersCarousel"));
const LatestBlogPosts = lazy(() => import("@/components/LatestBlogPosts"));
const FinalCTA = lazy(() => import("@/components/FinalCTA"));
const Footer = lazy(() => import("@/components/Footer"));
const WhatsAppButton = lazy(() => import("@/components/WhatsAppButton"));

const SectionFallback = () => <div className="min-h-[200px]" aria-hidden="true" />;

const Index = () => {
  return (
    <div className="min-h-screen">
      <Seo
        title="Skiathos Travellers — Local Travel Concierge"
        description="Plan Skiathos like a local: private boat charters, daily cruises, stays, transfers and curated experiences — booked in minutes."
        jsonLd={[
          {
            "@context": "https://schema.org",
            "@type": "Organization",
            name: "Skiathos Travellers",
            url: "https://www.skiathostravellers.com",
            logo: "https://www.skiathostravellers.com/src/assets/skiathos-logo.svg",
            description: "Local travel concierge for Skiathos and the Sporades.",
            areaServed: "Skiathos, Greece",
            sameAs: [
              "https://www.instagram.com/skiathostravellers",
              "https://www.facebook.com/skiathostravellers",
            ],
          },
          {
            "@context": "https://schema.org",
            "@type": "WebSite",
            name: "Skiathos Travellers",
            url: "https://www.skiathostravellers.com",
            potentialAction: {
              "@type": "SearchAction",
              target: "https://www.skiathostravellers.com/blog?q={search_term_string}",
              "query-input": "required name=search_term_string",
            },
          },
        ]}
      />
      <Navbar />
      <HeroSection />

      <Suspense fallback={<SectionFallback />}>
        <ServicesGrid />
        <PopularSearches />
        <SpecialOffersCarousel />
        <FeaturedExperiences />
        <RecentlyViewedCarousel />
        <AboutSection />
        <TestimonialsSection />
        <DestinationsSection />
        <LatestBlogPosts />
        <FinalCTA />
        <Footer />
        <WhatsAppButton />
      </Suspense>
    </div>
  );
};

export default Index;
